import React, { useState, useEffect } from "react";

import "./products.css";

import Authorization from "../../utils/secure/Authorization";
import PullToRefresh from "react-simple-pull-to-refresh";
import NavBar from "../../utils/nav/NavBar";
import NavMenu from "../../utils/nav/NavMenu";
import Search from "../../utils/search";
import Loading from "../../utils/loading";
import PaginateButtons from "../../utils/paginate";
import { GetExistencias } from "../../../services/productosServices";
import PillOptions from "../../utils/pillOptions";
import { formatNumber } from "../../../services/stringServices";

const Stocks = () => {
  const [permissionChecked, setPermissionChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [existencias, setExistencias] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [numPages, setNumPages] = useState(0);
  const [filteredItems, setFilteredItems] = useState([]);
  const [filtroExistencia, setFiltroExistencia] = useState("con Existencia");

  const pageLength = 15;

  useEffect(() => {
    cargar();
  }, []);

  const cargar = async () => {
    try {
      setLoading(true);
      let existencias = await GetExistencias();
      setExistencias(existencias);
      filterItems(existencias);
    } catch (error) {
      alert(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (search) => {
    setSearchText(search.toLowerCase());
    filterItems(existencias, search);
  };

  const handlePageChange = (selectedPage) => {
    setCurrentPage(selectedPage);
    filterItems(undefined, undefined, selectedPage);
  };

  const filterItems = (
    items = existencias,
    search = searchText,
    currPage = currentPage,
    filterExistencia = filtroExistencia
  ) => {
    let searchLowerCase = search.toLocaleLowerCase();
    let filtered = items.filter(
      (x) =>
        x.descripcion.toLowerCase().includes(searchLowerCase) ||
        x.categoria.toLowerCase().includes(searchLowerCase) ||
        x.proveedor.toLowerCase().includes(searchLowerCase)
    );

    if (filterExistencia === "con Existencia")
      filtered = filtered.filter((x) => x.existencia > 0);
    if (filterExistencia === "sin Existencia")
      filtered = filtered.filter((x) => x.existencia <= 0);

    let numPages = Math.floor(filtered.length / pageLength) - 1;

    setNumPages(numPages);

    let startIndex = currPage * pageLength;
    let endIndex = startIndex + pageLength;
    let page = filtered.slice(startIndex, endIndex);

    setFilteredItems(page);
  };

  return (
    <div id="stocks">
      {!permissionChecked && (
        <Authorization
          permission="Inventarios/Existencias"
          onPermissionGranted={() => setPermissionChecked(true)}
        />
      )}
      <PullToRefresh onRefresh={cargar}>
        <div className="page-header">
          <NavBar title="Existencias" navButtonComponent={<NavMenu />} />
          <div className="bar single">
            <div className="stocks--filtroExistencia">
              <PillOptions
                options={["con Existencia", "sin Existencia", "Todos"]}
                variant="primary"
                selected={filtroExistencia}
                onSelect={(option) => {
                  setFiltroExistencia(option);
                  filterItems(undefined, undefined, undefined, option);
                }}
              />
            </div>
          </div>
        </div>
        <div className="page-content">
          <Search
            initialSearchText={searchText}
            onSearch={(searchText) => handleSearch(searchText)}
          />
          <div className="page-list">
            {filteredItems.map((item) => (
              <div key={item.productoId} className="list-item grid">
                <div className="col1 div-center products--image ">
                  <img className="thumbnail" src={item.imagenUrl} />
                </div>
                <div className="col2 products--info">
                  <div className="list-item--heading">{item.descripcion}</div>
                  <div className="list-item--sub-heading">{item.categoria}</div>
                  <div className="list-item--sub-heading">{item.proveedor}</div>
                  <div className="div-right products--precio">
                    {formatNumber(item.existencia, 2)} {item.unidad}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </PullToRefresh>
      {!loading && (
        <PaginateButtons
          numPages={numPages}
          currentPage={currentPage}
          onPageChange={(pageNumber) => handlePageChange(pageNumber)}
        />
      )}
      {loading && <Loading />}
    </div>
  );
};

export default Stocks;
